import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from './PaymentSuccess.module.css';
import { capture } from '../analytics';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Get transaction ID from URL params if available
    const transactionId = searchParams.get('transaction_id');

    console.log('Payment success page loaded');
    console.log('Transaction ID:', transactionId);
    capture('payment_success_viewed', { transaction_id: transactionId });

    // Redirect to profile page immediately
    navigate('/profile', { replace: true });
  }, [navigate, searchParams]);

  return (
    <div className={styles.container}>
      <div className={styles.successCard}>
        <div className={styles.successIcon}>
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h1 className={styles.title}>Payment Successful!</h1>
        <p className={styles.message}>
          Your transaction has been completed successfully. We have emailed you details of your order.
        </p>
        <p className={styles.redirectMessage}>
          Redirecting to your profile page in 3 seconds...
        </p>
        <button
          className={styles.profileButton}
          onClick={() => navigate('/profile')}
        >
          Go to Profile Now
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
